<template>
  <!--理财课堂-->
  <div>
    <header class="header">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/logo1.png" class="img" alt="招商基金" />
          <!-- <img src="../assets/img/logo2.png" class="img" alt="投资者" /> -->
        </div>
        <div class="search" @click="$router.push({ path: '/search' })"></div>
      </div>
      <ul class="nav">
        <li>
          <router-link to="/" class="a">首 页</router-link>
        </li>
        <li
          v-for="(item, index) in navList"
          :key="item.id"
          @click="
            oneIndex = index
            getList(item.id)
          "
        >
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="a" :class="index == oneIndex ? 'sel' : ''">
            {{ item.name }}</router-link
          >
        </li>
      </ul>
    </header>

    <div class="sy_banner">
      <van-swipe class="sy_swipe" :autoplay="3000" indicator-color="#BEBDB9" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, i) in bannerList" :key="i">
          <img :src="item.image" class="img" />
        </van-swipe-item>
      </van-swipe>
      <div class="dots">
        <div class="nei">
          <i :class="i == current ? 'sel' : ''" v-for="(item, i) in bannerList" :key="i"></i>
        </div>
      </div>
    </div>
    <div class="modules-template" v-for="item in moduleList" :key="item.id">
      <!--卡片二-->
      <div class="main" v-if="item.show_data == 1 || item.show_data == 5">
        <div class="t_title mian_title">
          <span>{{ item.name }}</span>
          <div class="more" @click="levelThree(item.id, '', item.show_data)">更多></div>
        </div>
        <ul class="act_list bg2">
          <li v-for="val in item.child" :key="val.id" @click="levelThree(item.id, val.id, item.show_data)">
            <router-link to="" class="a">
              <img :src="val.image" alt="" class="img" />
              <div class="title">
                <span>{{ val.name }}</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <!--视频-->
      <div v-if="item.show_data == 2">
        <div class="t_title">
          <span>{{ item.name }}</span>
          <div class="more" @click="levelThree(item.id)">更多></div>
        </div>
        <ul class="sy_licai bg3">
          <li v-for="val in item.child" :key="val.id" @click="details(val.id, val.url)">
            <video :src="val.video_file" class="sp" :poster="val.image"></video>
            <div class="bo"></div>
          </li>
        </ul>
      </div>
      <!-- 图文 -->
      <div class="main" v-if="item.show_data == 3">
        <!--投资有招-->
        <div class="t_title mian_title">
          <span>{{ item.name }}</span>
          <div class="more" @click="levelThree(item.id)">更多></div>
        </div>
        <ul class="touzi_list bg3">
          <li v-for="val in item.child" :key="val.id" @click="details(val.id, val.url)">
            <img :src="val.image" class="img" />
            <div class="right">
              <div class="tit">{{ val.name }}</div>
              <div class="desc">{{ val.describe }}</div>
            </div>
          </li>
        </ul>
      </div>
      <!--卡片-->
      <div class="main mtb80" v-if="item.show_data == 4">
        <ul class="act_list">
          <li v-for="val in item.child" :key="val.id" @click="levelThree(item.id, val.id)">
            <router-link to="" class="a">
              <img :src="val.image" alt="" class="img" />
              <div class="title">
                <span>{{ val.name }}</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- footer -->
    <div class="di_tishi">
      <strong>风险提示 ：</strong><br />
      市场有风险，投资须谨慎。本网站相关观点为当前观点，未来可能随着市场的变化而变化，亦不构成任何投资建议及基金投资收益的保证。
    </div>
    <van-overlay :show="show">
      <van-loading color="#1989fa" />
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      oneIndex: '',
      current: 0,
      bannerList: [],
      navList: [],
      moduleList: [],
      show: false,
    }
  },
  created() {
    this.id = this.getQueryValue('id')
    this.oneIndex = this.getQueryValue('index')
    if (this.id == '') {
      this.id = localStorage.getItem('id')
      this.oneIndex = localStorage.getItem('oneIndex')
    } else {
      localStorage.setItem('id', this.id)
      localStorage.setItem('oneIndex', this.oneIndex)
    }
    this.getNav()
    this.getBanner()
    this.getList()
  },
  watch: {
    oneIndex() {
      this.id = this.getQueryValue('id')
      this.getBanner()
    },
  },
  methods: {
    //轮播
    onChange(index) {
      this.current = index
    },
    async getNav() {
      const res = await this.axios.get('/index/tabs')
      if (res.code === 1) {
        this.navList = res.data
      }
    },
    async getBanner() {
      this.show = true
      const res = await this.axios.get(`/items/banner?tabs_id=${this.id}`)
      console.log(res)
      if (res.code === 1) {
        this.bannerList = res.data
        this.show = false
      }
    },
    async getList(id) {
      if (!id) id = this.id
      const res = await this.axios.get(`/items/index?tabs_id=${id}`)
      if (res.code === 1) {
        this.moduleList = res.data
        console.log(this.moduleList)
      }
    },
    levelThree(id, cards_id, show_data) {
      if (show_data == 5) {
        this.$router.push({ path: `/dongjian?id=${id}&index=${this.oneIndex}` })
      } else {
        this.$router.push({
          path: `/licai2?id=${id}&cards_id=${cards_id}&index=${this.oneIndex}`,
        })
      }
    },
    details(id, url) {
      if (url) {
        location.href = url
      } else {
        this.$router.push({ path: `/levelThree?id=${id}` })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: -0.6rem;
  .top {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.3rem;
    background: #fff;
    .logo {
      display: flex;
      height: 1rem;
      align-items: center;
      .img {
        max-height: 0.46rem;
        margin-right: 0.4rem;
      }
    }
    .search {
      width: 1rem;
      height: 1rem;
      background: url(../assets/img/search.png) no-repeat center center;
      background-size: 0.41rem;
    }
  }
  .nav {
    width: 100%;
    background: url(../assets/img/bg_01.png) no-repeat left top;
    background-size: 100% 100%;
    height: 0.96rem;
    line-height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    li {
      padding: 0;
      margin: 0;
      width: 50%;
      text-align: center;
      height: 0.96rem;
      display: flex;
    }
    .a {
      width: 100%;
      color: #fff;
      font-size: 0.28rem;
      height: 0.8rem;
      display: inline-block;
      line-height: 0.8rem;
      position: relative;
      &.sel {
        font-weight: bold;
        background: url(../assets/img/bg_02.png) no-repeat center 85%;
        background-size: auto 0.02rem;
      }
    }
  }
}
.main {
  padding: 0 0.32rem;
}
.sy_banner {
  position: relative;
  .sy_swipe {
    .img {
      display: block;
      width: 100%;
    }
  }
  .dots {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
    height: 0.4rem;
    background-size: 100% 100%;
    text-align: right;
    padding-right: 0.3rem;
    line-height: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    .nei {
      display: flex;
    }
    i {
      width: 0.1rem;
      height: 0.1rem;
      background: #fff;
      border-radius: 5px;
      display: inline-block;
      margin-left: 8px;
      transition: 0.4s;
    }
    .sel {
      width: 0.9rem;
    }
  }
}
.t_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.3rem;
  box-sizing: border-box;
  padding: 0 0.32rem;
  span {
    height: 0.74rem;
    line-height: 0.74rem;
    font-size: 0.3rem;
    color: #272a2c;
    font-weight: bold;
  }
  .more {
    line-height: 0.5rem;
    color: #666666;
    font-size: 0.22rem;
  }
}
.mian_title {
  padding: 0;
}
.act_list {
  li {
    margin-bottom: 0.2rem;
    width: 100%;
    overflow: hidden;
    border-radius: 6px;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    .img {
      width: 100%;
      display: block;
    }
    .title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      color: #fff;
      line-height: 0.6rem;
      font-weight: bold;
      span {
        text-shadow: 0.03rem 0.03rem 0.07rem rgba(40, 39, 40, 0.34);
        font-size: 0.52rem;
      }
    }
  }
}
.sy_licai {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  overflow-x: auto;
  padding-left: 0.32rem;
  box-sizing: border-box;
  height: 4.2rem;
  li {
    .state {
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      padding: 0 5px;
      line-height: 0.26rem;
      font-size: 0.17rem;
      position: absolute;
      top: 5px;
      right: 5px;
    }
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    display: inline-block;
    width: 3.2rem;
    height: 3.6rem;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 0.15rem;
    background: #fff;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    .bo {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/img/bo.png) no-repeat center center;
      background-size: 0.56rem;
      left: 0;
    }
    .sp {
      width: 100%;
      display: block;
      height: 100%;
      background: #000;
      object-fit: cover;
    }
  }
}
.sy_licai::-webkit-scrollbar {
  display: none;
}
.bg1 {
  background: url(../assets/img/bg_06.png) no-repeat left bottom;
  background-size: 5.3rem;
}
.bg2 {
  background: url(../assets/img/bg_06.png) no-repeat right bottom;
  background-size: 5.3rem;
}
.bg3 {
  background: url(../assets/img/bg_07.png) no-repeat left bottom;
  background-size: 3.6rem;
}
.mtb80 {
  margin: 0.8rem 0;
}
.touzi_list {
  li {
    margin-bottom: 0.18rem;
    background: #fff;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
    align-items: center;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
  }
  .img {
    width: 2.9rem;
    height: 1.5rem;
    object-fit: cover;
    flex-shrink: 0;
  }
  .type {
    position: absolute;
    top: 3px;
    right: 0.15rem;
    line-height: 0.24rem;
    background: #f7eaec;
    padding: 0 5px;
    color: #e34f66;
    font-size: 0.18rem;
  }
  .right {
    padding: 0.2rem;
    width: 100%;
    .tit {
      padding-left: 0.16rem;
      background: url(../assets/img/bg_05.png) no-repeat left top;
      background-size: 0.08rem;
      color: #4d4d4d;
      font-size: 0.3rem;
      line-height: 0.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .desc {
      color: #999999;
      line-height: 0.24rem;
      font-size: 0.2rem;
      padding-left: 0.16rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.di_tishi {
  padding: 0.6rem 0.32rem;
  color: rgba(153, 153, 153, 0.59);
  line-height: 0.28rem;
  font-size: 0.18rem;
  font-weight: normal;
}
.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
